import { render, staticRenderFns } from "./abnormalRelease.vue?vue&type=template&id=67594510&scoped=true"
import script from "./abnormalRelease.vue?vue&type=script&lang=js"
export * from "./abnormalRelease.vue?vue&type=script&lang=js"
import style0 from "./abnormalRelease.vue?vue&type=style&index=0&id=67594510&prod&scoped=true&lang=css"
import style1 from "./abnormalRelease.vue?vue&type=style&index=1&id=67594510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67594510",
  null
  
)

export default component.exports